import { BrandingImage, BrandingStyle, useParams } from "bcms-react";
import PageLayoutContainer from "components/shared/containers/PageLayoutContainer";
import PageFooterView from "components/shared/views/PageFooterView";
import PageHeaderView, { MobilePageHeaderView } from "components/shared/views/PageHeaderView";
import React from "react";
import MainNavView from "../MainNavView";
import UtilityNavView from "../UtilityNavView";
import "./styles.css";
/**
 * @function PageContentView
 * @param {React.Component} children - Content that's contained in this page.
 * @returns {React.Component}
 * @example
 * <PageContentView>
 *  <LeftColumn />
 *  <RightColumn />
 * </PageContentView>
 */
export default function PageContentView(props) {
  const showHeader = props.showHeader ?? true;
  const hidePageBody = props.hidePageBody ?? false;

  return (
    <BrandingStyle style={ hidePageBody ? {} : { "backgroundImage":"url([[main_bg_image_abi22]])" } } className="page-content-view flex-container flex-vertical" >
      { showHeader && 
      <>
        <PageHeaderView>
          <div className="upper-header-wrapper flex-container flex-horizontal align-center">
            <div className="flex-width">
              <a href="#accountSummary">
                <BrandingImage id="header_logo_abi22" className="page-header-logo" />
              </a>
            </div>
            <UtilityNavView/>
          </div>
          <MainNavView/>
        </PageHeaderView>
        <MobilePageHeaderView />
      </>
      }
      <PageLayoutContainer className={ hidePageBody ? "visibility-hidden" : "" }>
        {props.children}
      </PageLayoutContainer>
      { !hidePageBody && <PageFooterView /> }
      
    </BrandingStyle>
  );
}